export default "__VITE_ASSET__BWXucKo4__"